import { designDisciplines } from "@/data/design-disciplines";

<global-nav defaultTheme=$global.theme/>
<section-observer color="neutral-primary">
    <about-hero/>
    <text-carousel paddingBlock=["none", "none"]/>
</section-observer>
<section-observer color="neutral-secondary">
    <sidebar-layout sections=designDisciplines paddingBlock=["xl", "lg"]/>
</section-observer>
<section-observer color="violet">
    <big-cta paddingBlock=["xl", "lg"]>
        <@headline>Ready to design your future at eBay?</@headline>
        <@cta
            href="https://jobs.ebayinc.com/us/en/c/design-ux-jobs"
            target="_blank">
            eBay Careers
        </@cta>
    </big-cta>
</section-observer>
